import { useState } from "react";
import Chat from "@/features/chat/Chat";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@/components/ui/button";
import { FileUpload } from "@/components/component/file-upload";
import PageLayout from "@/ui/PageLayout";
import { useChatStore } from "@/stores/ChatStore";
import { useStartChat } from "@/features/chat/useStartChat";

const DocumentChat = () => {
  const proposalId = useChatStore((state) => state.proposalId);
  const [queryFiles, setQueryFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [tempProposalId, setTempProposalId] = useState(proposalId);

  const { data: chatData, isLoading: isChatLoading } = useStartChat({
    searchType: "upload",
    proposal_id: tempProposalId,
    purpose: "chat",
    files: queryFiles,
    queryProps: {
      onSuccess: (data) => {
        useChatStore.setState({ proposalId: tempProposalId });
      },
    },
  });

  return (
    <div className="min-h-screen">
      <PageLayout
        heading="Chat with your Document(s)"
        description="Got files from somewhere else? Upload your files and start an interactive conversation with SamSearch AI to extract insights effortlessly."
      >
        <div className="grid grid-cols-3 gap-4 relative -mb-32">
          {/* Left side - File Upload */}
          <div className="col-span-1 border-r pr-4">
            <h2 className="text-lg font-semibold mb-2">Document Files</h2>
            <FileUpload
              files={files}
              setFiles={setFiles}
              inputProps={{
                accept: ".pdf,.doc,.docx",
                multiple: true,
              }}
              containerProps={{
                className:
                  "h-32 border-dashed border-2 rounded-md flex items-center justify-center p-4",
              }}
            />
            {files.length > 0 && (
              <Button
                className="w-full mt-4"
                onClick={() => {
                  const newProposalId = uuidv4();
                  setTempProposalId(newProposalId);
                  setQueryFiles(files);
                }}
              >
                Start New Chat
              </Button>
            )}
          </div>
          {/* Right side - Chat with fixed height */}
          <div className="col-span-2 sticky top-4 self-start h-[calc(100vh-4rem)] flex flex-col">
            <h1 className="text-xl font-bold mb-2">Document Chat</h1>
            <div className="flex-1 overflow-hidden h-full">
              <Chat
                proposal_id={tempProposalId}
                purpose="chat"
                searchType="upload"
                context=""
                className="flex-1 h-full overflow-auto"
                chatData={chatData}
                isChatLoading={isChatLoading}
                hideCloseButton
              />
            </div>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default DocumentChat;
